import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/emitters/executions')({
  component: () => <Outlet />,
});
